var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox-container"},[_c('input',{ref:"checkboxInput",staticClass:"checkbox",attrs:{"type":"checkbox","disabled":_vm.readOnly},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}}),_c('div',{staticClass:"checkbox-custom empty",class:{
      orange: _vm.value && !_vm.readOnly,
      grey: (_vm.checked && _vm.readOnly) || (_vm.checked && _vm.color === 'grey'),
      disabled: _vm.readOnly,
    }},[(_vm.value)?_c('CheckboxIcon'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }